<template>
  <div id="home">
    <Header></Header>
    <slideshow></slideshow>
    <div class="content">
      <div class="tabqie">
        <el-tabs type="border-card" stretch style="aaaa" v-model="Name">
          <el-tab-pane label="公司新闻" name="1">
            <div class="tabqie_content">
              <div class="lbt">
                <el-carousel indicator-position="outside">
                  <el-carousel-item v-for="(item, index) in list.slice(0,3)" :key="index">
                    <div class="imgs">
                      <img :src="url+item.image" @click="tiaozhuan(item.id, 2)" />
                    </div>
                  </el-carousel-item>

                </el-carousel>
              </div>
              <div class="left">
                <div class="title">
                  <div style="font-size:20px;color: #3d3d3d;">
                    <!-- {{ list2.fu_title }} -->
                  </div>
                </div>
                <ul class="liebiao">
                  <li @click="tiaozhuan(item.id, 2)" v-for="(item, index) in list" :key="index"
                    class="liebiao_li">
                    <span class="q1">{{ item.title }}</span>
                    <span class="q2">{{ item.addTime }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="行业新闻" name="2">
            <div class="tabqie_content xyxq2">
              <div class="lbt">
                <img src="../../assets/xyxwsy.jpg" alt="" class="xytup">
              </div>
              <div class="left">
                <div class="title">
                  <div style="font-size:20px;color: #3d3d3d;">

                  </div>
                </div>
                <ul class="liebiao">
                  <li @click="tiaozhuan(item.id, 3)" v-for="(item, index) in arr" :key="index"
                    class="liebiao_li">
                    <span class="q1">{{ item.title }}</span>
                    <span class="q2">{{ item.addTime }}</span>

                  </li>
                </ul>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="视频" name="3">
            <ul class="sp">
              <li v-if="playback.video">
                <span class="spbt">{{ playback.title }}</span>
                <video :src="url+playback.video" controls preload="auto" class="sp_bf"></video>
              </li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="show_box">
        <div class="show_text">
          <p class="show_chinese">业务展示</p>
          <p class="show_english">showbusiness</p>
        </div>
      </div>
      <div class="show_bgc">
        <div class="show_img2" @click="yh(0,31)">
          <img src="../../assets/img/f65b39a2b64ff89b5ad7647cf309f32.png" alt="">
        </div>
        <div class="show_img2" @click="yh(1,32)">
          <img src="../../assets/img/2fff5871d79b20b2667e7f7b627fb31.png" alt="">
        </div>
        <div class="show_img2" @click="yh(2,33)">
          <img src="../../assets/img/91ecb50c912759e193bc3a1aa77f5fc.png" alt="">
        </div>

        <div class="show_img2" @click="yh(3,34)">
          <img src="../../assets/img/559b1a8f000c86794bc6bc27c3f9279.png" alt="">
        </div>
        <div class="show_img2" @click="yh(4,35)">
          <img src="../../assets/img/cyfw.png" alt="">
        </div>
        <div class="show_img2" @click="yh(5,36)">
          <img src="../../assets/img/0aa7a6075da164bafc1c271af52c4e2.png" alt="">
        </div>

      </div>

      <div class="boxss">
        <div class="boxss_box">
          <a href="https://finance.sina.com.cn/realstock/company/sh000001/nc.shtml">
            <div class="index_imgs"> </div>
          </a>

          <a href="https://finance.sina.com.cn/realstock/company/sz000520/nc.shtml">
            <div class="index_imgs2"> </div>
          </a>
          <a href="http://data.eastmoney.com/cjsj/oil_default.html">
            <div class="index_imgs3"> </div>
          </a>
          <a href="https://www.sse.net.cn/index/singleIndex?indexType=ccfi">
            <div class="index_imgs4"> </div>
          </a>
        </div>




      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import slideshow from "../../components/haed/slideshow.vue";
import qs from "qs";
export default {
  name: "hone",
  components: {
    Header,
    Footer,
    slideshow
  },
  data() {
    return {
      cur: 1,
      arr: [],
      list: [],
      list2: [],
      playback: {},
      simgurl1: "",
      simgurl2: "",
      simgurl3: "",
      simgurl4: "",
      simgurl5: "",
      Name: "1",
      url:this.$axios.defaults.baseURL,
    };
  },
  created() {
    this.newq();
    this.Companynews();
    this.Videoplayback();
    if (this.$route.query.sd) {
      this.Name = this.$route.query.sd
    }
    
  },
  methods: {
    yh(id,type) {
      this.$router.push({ path: "../development?name=" + id +"&type="+type});
    },
    yy(id) {
      this.$router.push({ path: "../development?name=" + id });
    },
    yw(id) {
      this.$router.push({ path: "../development?name=" + id });
    },
    hy(id) {
      this.$router.push({ path: "../development?name=" + id });
    },
    cd(id) {
      this.$router.push({ path: "../development?name=" + id });
    },
    cy(id) {
      this.$router.push({ path: "../development?name=" + id });
    },
    tx(id) {
      this.$router.push({ path: "../development?name=" + id });
    },
    tiaozhuan(id, type) {
      this.$router.push({ path: "/Companynews?id=" + id + "&menu=1" + "&type=" +type+ "&sd=" + 1 });
      // this.$router.push({ path: "/Companynews?id=" + id + "&bid=" + bid + "&name=" + name + "&sd=" + sd });
    },
    Videoplayback: function () {
      this.$axios({
        // method: "post",
        method: "get",
        url: "/changhang/index/list?menu=1&type=4",
        // url: "/index.php/show/showlist",
        // data: qs.stringify({
        //   id: 15,
        //   pageNum: 1,
        //   pageSize: 5
        // })
      })
        .then(res => {
          if(res.data.rows.length>0){
            this.playback = res.data.rows[0];
          }
        })
        .catch(res => {
          
        });
    },
    Companynews: function () {
      this.$axios({
        // method: "post",
        method: "get",
        url: "/changhang/index/list?menu=1&type=3&pageNum=1&pageSize=9&remark=-1",
        // url: "/index.php/news/newslist",
        // data: qs.stringify({
        //   id: 13,
        //   pageNum: 1,
        //   pageSize: 9
        // })
      })
        .then(res => {
          // this.list = res.data.data;
          this.arr = res.data.rows;
        })
        .catch(res => {
          
        });
    },
    enterprise() {
      this.$router.push({ path: "../enterprise/enterprise.vue" });
    },

    news() {
      this.$router.push({ path: "/index" });
    },
    newq: function () {
      this.$axios({
        method: "get",
        url: "/changhang/index/list?menu=1&type=2&pageNum=1&pageSize=9&remark=-1",
      })
        .then(res => {
          // this.information = res.data.data;
          this.list = res.data.rows;
          // this.simgurl1 = res.data.data[0].simgurl
          // this.simgurl2 = res.data.data[1].simgurl
          // this.simgurl3 = res.data.data[2].simgurl
          // this.simgurl4 = res.data.data[3].simgurl
          // this.simgurl5 = res.data.data[4].simgurl
          // this.list2 = res.data.data[0];
        })
        .catch(res => {
         
        });
    }
  }
};
</script>
<style scoped>
#home {
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  /* -webkit-filter: grayscale(100%); */
}

/* .el-tab-pane{
  margin-left:0px !important;
} */
.xyxq2 {
  padding-bottom: 2.7%;
}

.xytup {
  height: 300px;
  width: 465px;
}

.spbt {
  text-align: center;
  display: block;
  width: 800px;
}

.imgs {
  width: 100%;
  height: 15v;
}

.imgs img {
  /* width: 100%; */
  width: 465px;
  height: 100%;
}

.el-carousel__container {
  /* height: 14vw; */
}

.el-carousel .el-carousel--horizontal {
  background-color: #000;
  height: 15vw;
}

.el-carousel__item,
.is-animating {
  /* height: 15vw; */
}

.lbt {
  width: 50%;
  padding-top: 2%;
  margin-left: 2%;
}

/* .aaaa{
  width: 800px;
  height: 200px;
  background-color: #000;
} */
.liebiao_li {
  margin-bottom: 1%;
  margin-left: 1%;
  font-size: 16px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.liebiao_li:hover {
  color: red;
}

.boxss {
  width: 100%;
  height: 200px;
  margin: 0 auto;
  margin-bottom: 2%;
  display: flex;
  justify-content: space-between;
  background-color: #cccccc;
  overflow: hidden;
}

.boxss_box {
  width: 1000px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}

.index_imgs {
  width: 200px;
  height: 170px;
  background: url("../../assets/img/564a8f8269f8b599d3c8d371c502e82.jpg") no-repeat;
  background-size: 100%;
  margin-top: 10px;

  /* width: 20%;
  height: 5vw; */
}

.index_imgs:hover {
  cursor: pointer;
  width: 200px;
  height: 170px;
  /* background: url("../../assets/img/4001b4564ab06cf41705e9682730d1e.jpg") no-repeat; */
  background: url("../../assets/img/agzs1.png") no-repeat;
  background-size: 100%;

}

.index_imgs2 {
  width: 200px;
  height: 170px;
  background: url("../../assets/newImg/tar.png") no-repeat;
  background-size: 100%;
  margin-top: 10px;
}

.index_imgs2:hover {
  cursor: pointer;
  width: 200px;
  height: 170px;
  background: url("../../assets/img/chfh1.png") no-repeat;
  background-size: 100%;
}

.index_imgs3 {
  width: 200px;
  height: 170px;
  background: url("../../assets/img/4904a7475d622934ceedf1f9f2081d7.jpg") no-repeat;
  background-size: 100%;
  margin-top: 10px;
}

.index_imgs3:hover {
  width: 200px;
  height: 170px;
  background: url("../../assets/img/yjzs1.png") no-repeat;
  background-size: 100%;
}

.index_imgs4 {
  width: 200px;
  height: 170px;
  background: url("../../assets/img/4d3bd4e0737b3e6b38aa377bb457392.jpg") no-repeat;
  background-size: 100%;
  margin-top: 10px;
}

.index_imgs4:hover {
  width: 200px;
  height: 170px;
  background: url("../../assets/img/hyzs1.png") no-repeat;
  background-size: 100%;
}

.show_img2 {
  width: 30%;
  margin-top: 2%;
}

.show_img2 :hover {
  cursor: pointer;
  box-shadow: 0 0 15px 1px #ccc;
}

.show_img2 img {
  width: 100%;
  height: 100%;
}

.show_img3 {
  width: 30%;
}

.show_img3:hover {}

.show_img3 img {
  width: 100%;
  height: 100%;
}

.show_bgc {
  width: 1000px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 2%;
}

.show_text {
  text-align: center;
  font-size: 3vw;
}

.show_chinese {
  font-size: 2vw;
  color: #3d3d3d;
}

.show_english {
  font-size: 1.2vw;
  color: #3d3d3d;
  margin-top: 0.5vw;
}

.show_box {
  width: 100%;

  margin-top: -1.4vw;
}

.show_img {
  width: 90%;
  height: 7vw;
  margin: 0 auto;
  margin-top: 3%;
}

.show_img:hover {
  cursor: pointer;
  box-shadow: 0 0 15px 1px #ccc;
}

.show_img img {
  width: 100%;
  height: 100%;
}

.arr4 {
  font-size: 1.6vw;
  color: #3d3d3d;
  margin-left: 1%;
}

.arr1 {
  text-align: center;
  font-size: 16px;
  color: #3d3d3d;
}

.arr2 {
  text-align: center;
  font-size: 14px;
  margin-top: 10px;
  color: #3d3d3d;
}

.arr3 {
  text-align: center;
  font-size: 14px;
  color: #3d3d3d;
  margin-top: 10px;
}

.imgs {
  /* width: 1200px; */
}

.imgss img {
  width: 100%;
  height: 100%;
}

/* .imgs img {
  width: 100%;
  height: 100%;
} */
.sp_bf {

  width: 800px;
  height: 450px;
  margin-top: 2%;
  /* margin: 5% 0; */
}

.sp {
  display: flex;

  flex-wrap: wrap;
}

.sp li {
  width: 800px;
  height: 550px;
  margin: 10px;
  margin: 0 auto;
}

.sp li img {
  width: 100%;
  height: 100%;
}

/* .Walkinglantern{
  height: 300px;
  width: 100%;
} */

.xxzx {
  display: flex;
}

.xxzx_img {
  width: 45%;
  height: 15vw;
  margin-left: 1vw;
}

.xxzx_img img {
  width: 100%;
  height: 100%;
}

.xxzx_title {
  width: 50%;
  margin-left: 1%;
}

/* .xxzx_title h2 {
  text-align: center;
  
} */
.hanyun {
  position: absolute;
  top: 20%;
  left: 40.5%;
}

.youjia {
  position: absolute;
  bottom: 18%;
  right: 32%;
}

.hy_x {
  display: inline-block;
  width: 4vw;
  border-top: 1px solid #000;
  vertical-align: middle;
}

.yj_x {
  display: inline-block;
  width: 4vw;
  border-top: 1px solid;
  vertical-align: middle;
}

.zhishu {
  position: absolute;
  top: 25%;
  right: 29%;
}

.zhishu2 {
  position: absolute;
  left: 38.2%;
  top: 71%;
}

.zhishu2 .henxian2 {
  display: inline-block;
  width: 5vw;
  border-top: 1px solid #000;
  vertical-align: middle;
}

.zhishu .henxian {
  display: inline-block;
  width: 5vw;
  border-top: 1px solid #000;
  vertical-align: middle;
}

.title h2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 15%;
}

.liebiao {
  padding-top: 2%;
  line-height: 1.8;
}

.liebiao span {
  margin-left: 1%;
}

.liebiao .q1 {
  /* width: 70%; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left
}

.title div {
  color: #848484;
  margin: 10px;
}

.rigth_top {
  width: 45%;
  height: 15vw;
  margin-left: 2vw;
  display: flex;
  align-items: center;
}

.rigth_top img {
  width: 100%;
  height: 100%;
}

.rigth_bottom img {
  width: 44.6%;
}

.dingwei {
  position: absolute;
}

.tabqie {
  width: 1000px;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
  /* width: 60%;
  margin: 2% auto; */
}

.Stockindex {
  position: relative;
  background-color: #e7e7e7;
  /* height: 154vh; */
  margin: 2% 0;
}

.brokenline {
  position: relative;
  margin: 2% 0;
}

.brokenline img {
  margin: 1% 0;
  width: 35%;
  margin-left: 28%;
  display: block;
  border-radius: 10px;
}

.brokenline .brokenline_img1 {
  margin-left: 48%;
}

.brokenline .brokenline_img2 {
  margin-left: 26%;
}

.Stockindex img {
  margin: 1% 0;
  width: 35%;
  margin-left: 28%;
  display: block;
  border-radius: 10px;
}

.Stockindex .Stockindex_img1 {
  padding-top: 2%;
}

.Stockindex .Stockindex_img2 {
  padding-bottom: 2%;
  margin-top: -16vh;
  margin-left: 48%;
}

.tabqie_content {
  display: flex;

}

.tabqie_content .left {
  width: 50%;
  height: 308px;
  margin-right: 2%;
}

.tabqie_content ul li {
  /* line-height: 2vw; */
  margin-left: 2vw;
  color: #3d3d3d;
}

.Business {
  width: 80%;
  text-align: center;
  margin: 2% auto;
}

.zimu {
  text-align: center;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 38px;
  margin: 0;
}

.medium div {
  background-color: #494949;
  color: #fff;
}

.el-tabs--border-card>.el-tabs__header .el-tabs__item {
  font-size: 32px;
  height: 60px;
  line-height: 60px;
  border-radius: 24px 24px 0 0;
}

.el-tabs__item,
.is-top {
  border-radius: 24px 24px 0 0;
}

.el-tabs--border-card>.el-tabs__header {
  border-left: 24px;
}

.el-tabs,
.el-tabs--top,
.el-tabs--border-card {
  border: 20px;
}

.el-tabs,
.el-tabs--top,
.el-tabs--border-card {
  border-radius: 24px;
}

.tabs__item {
  font-size: 32px !important;
}

.tabqie .el-tabs__item {
  font-size: 24px !important;
  height: 50px !important;
  line-height: 50px !important;
}

/* @media screen and (max-width: 768px) { */
@media screen and (min-width: 320px) and (max-width: 750px) {
  .show_box {
    margin-top: 4%;
  }

  .tabqie {
    /* width: 800px; */
    /* display: none; */
    width: 96%;
    margin-top: 6%;
  }

  .tabqie_content .left {
    height: 100%;
  }

  .tabqie .el-tabs__nav-scroll .el-tabs__item {
    font-size: 12px !important;
  }

  .tabqie_content ul li {
    width: 198%;
    font-size: 12px;
  }

  .sp {
    height: 194px;
  }

  .sp li {
    width: 100%;
  }

  .spbt {
    width: 100%;
  }

  .sp_bf {
    width: 100%;
    height: 150px;
  }

  .tabqie .lbt {
    display: none;
  }

  .show_chinese {
    font-size: 28px;
  }

  .show_english {
    font-size: 16px
  }

  .show_bgc {
    width: 94%;
  }

  .boxss {
    width: 100%;
    height: 80px;
    padding-bottom: 2%;
  }

  .bottom_box {
    display: flex;
  }

  .boxss_box {
    width: 95%;

  }

  .index_imgs,
  .index_imgs2,
  .index_imgs3,
  .index_imgs4 {
    background-size: 100%;
    width: 81px;
    height: 60px;
  }

}</style>

<style>.el-tabs__content {
  margin-left: 0px !important;
}

.tabqie .el-tabs__item {
  font-size: 24px;
  height: 50px;
  line-height: 50px;
}

.el-tabs--border-card>.el-tabs__header {

  /* width: 99%;
    margin: 0 auto;
    margin-top: 50px; */
  /* border-radius: 40px; */
}

.el-tabs,
.el-tabs--top,
.el-tabs--border-card {
  overflow: hidden;
}

@media screen and (min-width: 320px) and (max-width: 750px) {
  .tabqie .el-tabs__item {
    font-size: 16px;
    height: 30px;
    line-height: 30px;
  }
}</style>


// WEBPACK FOOTER //
// src/pages/home/home.vue